import { t, tServer } from "../i18n/i18n";

/** Motif d'un point de passage obligé, rédigé comme dans le rapport de terrain (generex_engine/terrain_zone.py) :
 *  les cartes natives l'écrivent en anglais technique (« high node degree (8) », « bridge crossing / constrained
 *  passage ») ; sans motif, selon la nature du point ; sinon le texte du serveur, traduit s'il est connu (`tServer`).
 *  Même rédaction dans les exports (`generex_api/exports.py`, `chokepoint_reason`). */
export function chokepointReason(reason: unknown, kind: unknown): string {
  const text = typeof reason === "string" ? reason.trim() : "";
  const degree = /high node degree \((\d+)\)/.exec(text);
  if (degree) return t("Carrefour à {n} branches", { n: degree[1]! });
  if (text === "bridge crossing / constrained passage" || (!text && kind === "bridge")) {
    return t("Franchissement contraint");
  }
  if (!text) return t("Carrefour structurant");
  return tServer(text);
}
